export function readSaveToDisco() {
  const query = new URLSearchParams(document.location.search)
  const savingObj = query.get('so') ?? ''
  const savingUrl = query.get('su') ?? ''

  if (savingObj || savingUrl) {
    return { savingObj, savingUrl }
  } else {
    return { savingObj: null, savingUrl: null }
  }
}

export function readReferralLanding() {
  try {
    return localStorage.getItem('landing') || undefined
  } catch (err) {
    console.error(err)
    return undefined
  }
}
